export default __webpack_public_path__ + "static/media/a2.1baec21f.JPG";